import snakecaseKeys from 'snakecase-keys';

import { authorizedInstance as axios } from '~/utils';

const namespace = '/patients';

const patientService = {
  changeProfilePicture: (v, patient) => {
    const p = {
      fileName: v.file.title,
      fileType: v.file.type,
      base64Data: v.file.base64.split('base64,')[1],
    };

    return axios.post(`${namespace}/${patient}/avatar`, p);
  },

  dupCheck: async (data) => {
    let status;
    let response;

    console.log('dupCheck');

    const p = {
      ...data,
      birthDate: data.birthDate?.toISOString() || '',
      genderUid: data.gender,
      genderIdentityUid: data.genderIdentity,
    };

    try {
      const r = await axios.post(`${namespace}/matches`, JSON.stringify(snakecaseKeys(p, { deep: true })));

      response = r.data.data;
      status = 'success';

      return [status, response];
    } catch (error) {
      response = error;
      status = 'error';

      return [status, response];
    }
  },

};

export default patientService;
